import { NgModule } from '@angular/core'

import { FlxAccessDeniedThemeDirective } from './access-denied-theme.directive'
import { FlxBreadcrumbsThemeDirective } from './breadcrumbs-theme.directive'
import { FlxBulkFileUploadThemeDirective } from './bulk-file-upload-theme.directive'
import { FlxButtonThemeDirective } from './button-theme.directive'
import { FlxCardThemeDirective } from './card-theme.directive'
import { FlxChatThemeDirective } from './chat-theme.directive'
import { FlxCheckThemeDirective } from './check-theme.directive'
import { FlxCollectionPrototypeThemeDirective } from './collection-prototype-theme.directive'
import { FlxCollectionThemeDirective } from './collection-theme.directive'
import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'
import { FlxContainerThemeDirective } from './container-theme.directive'
import { FlxDatepickerCalendarThemeDirective } from './datepicker-calendar-theme.directive'
import { FlxDatepickerThemeDirective } from './datepicker-theme.directive'
import { FlxDocPreviewThemeDirective } from './doc-preview-theme.directive'
import { FlxErrorThemeDirective } from './error-theme.directive'
import { FlxFormFieldScopedVariantDirective } from './form-field-scoped-variant.directive'
import { FlxLayoutFormDirective } from './form.directive'
import { FlxHelperThemeDirective } from './helper-theme.directive'
import { FlxHelperTooltipThemeDirective } from './helper-tooltip-theme.directive'
import { FlxImageThemeDirective } from './image-theme.directive'
import { FlxInputThemeDirective } from './input-theme.directive'
import { FlxLabelThemeDirective } from './label-theme.directive'
import { FlxLinkThemeDirective } from './link-theme.directive'
import { FlxMarkdownThemeDirective } from './markdown-theme.directive'
import { FlxMessageThemeDirective } from './message-theme.directive'
import { FlxModalThemeDirective } from './modal-theme.directive'
import { FlxMultiSelectThemeDirective } from './multi-select-theme.directive'
import { FlxProgressBarThemeDirective } from './progress-bar-theme.directive'
import { FlxRadioThemeDirective } from './radio-theme.directive'
import { FlxSegmentedBtnThemeDirective } from './segmented-btn-theme.directive'
import { FlxSelectOptionThemeDirective } from './select-option-theme.directive'
import { FlxSelectThemeDirective } from './select-theme.directive'
import { FlxSeparatorThemeDirective } from './separator-theme.directive'
import { FlxSliderThemeDirective } from './slider-theme.directive'
import { FlxSpinnerThemeDirective } from './spinner-theme.directive'
import { FlxStepperThemeDirective } from './stepper-theme.directive'
import { FlxSwitchThemeDirective } from './switch-theme.directive'
import { FlxTabBarThemeDirective } from './tab-bar-theme.directive'
import { FlxTableThemeDirective } from './table-theme.directive'
import { FlxTaskManagementThemeDirective } from './task-management-theme.directive'
import { FlxTextThemeDirective } from './text-theme.directive'
import { FlxTextareaThemeDirective } from './textarea-theme.directive'
import { FlxTooltipThemeDirective } from './tooltip-theme.directive'

const themeDirectives = [
  FlxAccessDeniedThemeDirective,
  FlxButtonThemeDirective,
  FlxCardThemeDirective,
  FlxCheckThemeDirective,
  FlxCollectionPrototypeThemeDirective,
  FlxCollectionThemeDirective,
  FlxComponentThemeBaseDirective,
  FlxContainerThemeDirective,
  FlxDatepickerCalendarThemeDirective,
  FlxDatepickerThemeDirective,
  FlxDocPreviewThemeDirective,
  FlxErrorThemeDirective,
  FlxFormFieldScopedVariantDirective,
  FlxLayoutFormDirective,
  FlxHelperThemeDirective,
  FlxHelperTooltipThemeDirective,
  FlxInputThemeDirective,
  FlxLabelThemeDirective,
  FlxLinkThemeDirective,
  FlxMessageThemeDirective,
  FlxSeparatorThemeDirective,
  FlxRadioThemeDirective,
  FlxSegmentedBtnThemeDirective,
  FlxSelectOptionThemeDirective,
  FlxSelectThemeDirective,
  FlxSliderThemeDirective,
  FlxStepperThemeDirective,
  FlxSwitchThemeDirective,
  FlxTabBarThemeDirective,
  FlxTextThemeDirective,
  FlxTextareaThemeDirective,
  FlxTableThemeDirective,
  FlxMultiSelectThemeDirective,
  FlxModalThemeDirective,
  FlxImageThemeDirective,
  FlxSpinnerThemeDirective,
  FlxTaskManagementThemeDirective,
  FlxChatThemeDirective,
  FlxBreadcrumbsThemeDirective,
  FlxBulkFileUploadThemeDirective,
  FlxProgressBarThemeDirective,
  FlxMarkdownThemeDirective,
  FlxTooltipThemeDirective,
]

@NgModule({
  imports: themeDirectives,
  exports: themeDirectives,
})
export class FlxThemeModule {}
